import { FlourDust, OvenDial, Steam } from "../../components/motifs";
import { Ico } from "../../components/shell";
import { navigate } from "../../router";

export function StateLoading() {
  return (
    <div className="bk bk-grain" style={{ display: "grid", placeItems: "center", minHeight: "100vh", overflow: "hidden" }}>
      <div style={{ position: "absolute", inset: 0 }}>
        <FlourDust count={18} />
      </div>
      <div style={{ textAlign: "center", position: "relative", zIndex: 1, padding: 40 }}>
        <div style={{ position: "relative", display: "inline-grid", placeItems: "center" }}>
          <div style={{ position: "absolute", left: "50%", top: -30, transform: "translateX(-50%)" }}>
            <Steam count={3} color="var(--crust-soft)" height={30} />
          </div>
          <div style={{ width: 110, height: 110, borderRadius: 32, background: "var(--red)", display: "grid", placeItems: "center", boxShadow: "var(--sh-red)" }}>
            <OvenDial size={66} color="#fff" spin />
          </div>
        </div>
        <h2 style={{ fontSize: 30, fontWeight: 800, letterSpacing: "-.03em", marginTop: 26 }}>Preheating Bakeoff…</h2>
        <p style={{ color: "var(--ink-soft)", fontSize: 15, fontWeight: 600, marginTop: 6 }}>Warming the ovens and dusting the counters.</p>
        <div style={{ width: 220, height: 8, borderRadius: 8, background: "var(--inset)", margin: "24px auto 0", overflow: "hidden" }}>
          <div
            style={{
              height: "100%",
              width: "55%",
              borderRadius: 8,
              background: "linear-gradient(90deg, var(--gold), var(--red), var(--gold))",
              backgroundSize: "200% 100%",
              animation: "bk-shimmer 1.4s linear infinite",
            }}
          />
        </div>
      </div>
    </div>
  );
}

export function StateEmpty({ onAction }: { onAction?: () => void }) {
  return (
    <div className="bk bk-grain" style={{ display: "grid", placeItems: "center", minHeight: "100vh" }}>
      <div style={{ textAlign: "center", position: "relative", zIndex: 1, padding: 40 }}>
        <div style={{ width: 150, height: 90, margin: "0 auto", borderRadius: 18, position: "relative", background: "var(--surface-warm)", border: "2px solid var(--line)", boxShadow: "var(--sh-sm)" }}>
          <div style={{ position: "absolute", inset: 12, borderRadius: 12, border: "2px dashed var(--crust-soft)", opacity: 0.5 }} />
          <div style={{ position: "absolute", left: -14, top: "50%", width: 18, height: 12, borderRadius: 6, transform: "translateY(-50%)", border: "2px solid var(--line)", background: "var(--surface-warm)" }} />
          <div style={{ position: "absolute", right: -14, top: "50%", width: 18, height: 12, borderRadius: 6, transform: "translateY(-50%)", border: "2px solid var(--line)", background: "var(--surface-warm)" }} />
        </div>
        <h2 style={{ fontSize: 27, fontWeight: 800, letterSpacing: "-.02em", marginTop: 26 }}>No questions baked yet</h2>
        <p style={{ color: "var(--ink-soft)", fontSize: 15, fontWeight: 600, marginTop: 6, maxWidth: 320 }}>
          Your question bank is empty. Let's prep your first batch and get the team rising.
        </p>
        <button className="bk-btn bk-btn--primary bk-btn--lg" style={{ marginTop: 22 }} onClick={onAction ?? (() => navigate("/builder"))}>
          <Ico name="plus" size={16} /> Bake your first question
        </button>
      </div>
    </div>
  );
}

export function StateError({ onRetry }: { onRetry?: () => void }) {
  return (
    <div className="bk bk-grain" style={{ display: "grid", placeItems: "center", minHeight: "100vh" }}>
      <div style={{ textAlign: "center", position: "relative", zIndex: 1, padding: 40 }}>
        <div style={{ width: 120, height: 92, margin: "0 auto", position: "relative", display: "grid", placeItems: "end center" }}>
          <div style={{ width: 110, height: 40, borderRadius: "50% 50% 16px 16px / 70% 70% 16px 16px", background: "linear-gradient(var(--crust-soft), var(--crust))", boxShadow: "var(--sh)", transform: "rotate(-4deg)" }} />
          <div style={{ position: "absolute", top: 6, left: "50%", transform: "translateX(-50%) rotate(-8deg)", opacity: 0.5 }}>
            <Steam count={2} color="var(--crust-soft)" height={18} />
          </div>
        </div>
        <h2 style={{ fontSize: 26, fontWeight: 800, letterSpacing: "-.02em", marginTop: 26 }}>Something collapsed in the oven</h2>
        <p style={{ color: "var(--ink-soft)", fontSize: 15, fontWeight: 600, marginTop: 6, maxWidth: 340 }}>
          Even master bakers get a flat loaf now and then. Catch your breath and give it another go.
        </p>
        <div style={{ display: "flex", gap: 10, justifyContent: "center", marginTop: 22 }}>
          <button className="bk-btn bk-btn--primary bk-btn--lg" onClick={onRetry ?? (() => location.reload())}>
            <Ico name="clock" size={16} /> Try again
          </button>
          <button className="bk-btn bk-btn--ghost bk-btn--lg" onClick={() => navigate("/")}>
            Back to dashboard
          </button>
        </div>
        <div className="mono" style={{ fontSize: 12, color: "var(--ink-faint)", marginTop: 18, fontWeight: 700 }}>ERR_OVEN_500 · session 428301</div>
      </div>
    </div>
  );
}

/** Gallery route showing all three states. */
export default function StatesGallery() {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <StateLoading />
      <StateEmpty />
      <StateError />
    </div>
  );
}
